module.exports = __webpack_public_path__ + "img/fill.3c860005.png";